namespace $ { $mol_style_attach( "mol/form/group/group.view.css",
 "[mol_form_group] {\n\tflex-wrap: wrap;\n\tgap: var(--mol_gap_block);\n}\n\n[mol_form_group] > * {\n\tflex: 1 1 18rem;\n}\n"
) }